import { render, staticRenderFns } from "./workBaseDays.vue?vue&type=template&id=224016d1&scoped=true"
import script from "./workBaseDays.vue?vue&type=script&lang=js"
export * from "./workBaseDays.vue?vue&type=script&lang=js"
import style0 from "./workBaseDays.vue?vue&type=style&index=0&id=224016d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224016d1",
  null
  
)

export default component.exports